import { Fade, Grid } from '@mui/material';
import { makeStyles } from '@mui/styles';
import { PortalPermissions } from 'queries';

import HomeLayout from 'layouts/home-layout';
import useHasPortalPermission from 'utils/useHasPortalPermission';

import GetStarted from './components/get-started';
import MyProducts from './components/my-products';
import UserActions from './components/user-actions';

const useStyles = makeStyles(() => ({
  container: {
    padding: '5%',
    flexGrow: 1,
  },
  chatButton: {
    position: 'fixed',
    right: 40,
    bottom: 150,
  },
}));

const Dashboard = () => {
  const classes = useStyles();
  const hasPortalPermissionConcierge = useHasPortalPermission(PortalPermissions.Concierge);

  return (
    <HomeLayout>
      <Fade in={true}>
        <>
          <div className={classes.container}>
            <Grid container spacing={3}>
              <Grid item md={6}>
                <MyProducts />
                {hasPortalPermissionConcierge ? <UserActions /> : <GetStarted />}
              </Grid>
              <Grid item md={6} xs={12}></Grid>
            </Grid>
          </div>
        </>
      </Fade>
    </HomeLayout>
  );
};

export default Dashboard;
